module.exports = __webpack_public_path__ + "img/HoverFeedbackOkay.2067ac4a.png";